import { useRef, useEffect } from "react";
import { EventData } from "mapbox-gl";
import { CustomLayer } from "../../../services/map/interfaces/custom-layer";
import { MapEvent } from "../../../services/map/interfaces/map-event";
import { MapService } from "../../../services/map/MapService";
import { useDependency } from "../../../contexts/DependencyContext";
// import styles from "./Layer.module.scss";

interface LayerProps
{
    layer: CustomLayer;
    before?: string;
    onClick?: (e?: EventData) => void;
    onDblClick?: (e?: EventData) => void;
    onMouseDown?: (e?: EventData) => void;
    onMouseUp?: (e?: EventData) => void;
    onMouseMove?: (e?: EventData) => void;
    onMouseEnter?: (e?: EventData) => void;
    onMouseLeave?: (e?: EventData) => void;
    onMouseOver?: (e?: EventData) => void;
    onMouseOut?: (e?: EventData) => void;
    onContextMenu?: (e?: EventData) => void;
    onTouchStart?: (e?: EventData) => void;
    onTouchEnd?: (e?: EventData) => void;
    onTouchCancel?: (e?: EventData) => void;
}

const Layer = (props: LayerProps): null =>
{
    const mapService = useDependency(MapService);
    const layerId = useRef<string>(props.layer.id);
    const eventsRef = useRef<MapEvent[]>([
        { name: "click", callback: props.onClick },
        { name: "dblclick", callback: props.onDblClick },
        { name: "mousedown", callback: props.onMouseDown },
        { name: "mouseup", callback: props.onMouseUp },
        { name: "mousemove", callback: props.onMouseMove },
        { name: "mouseenter", callback: props.onMouseEnter },
        { name: "mouseleave", callback: props.onMouseLeave },
        { name: "mouseover", callback: props.onMouseOver },
        { name: "mouseout", callback: props.onMouseOut },
        { name: "contextmenu", callback: props.onContextMenu },
        { name: "touchstart", callback: props.onTouchStart },
        { name: "touchend", callback: props.onTouchEnd },
        { name: "touchcancel", callback: props.onTouchCancel }
    ].filter(x => x.callback));

    useEffect(() =>
    {
        mapService.setSource(props.layer.id, props.layer.source);
        mapService.setLayer(props.layer.id, props.layer.options, props.before);

        return () =>
        {
            mapService.removeLayer(props.layer.id);
            mapService.removeSource(props.layer.id);
        }
    }, [mapService, props.layer, props.before]);

    useEffect(() =>
    {
        if (!layerId?.current || !eventsRef.current?.length) return;

        const events = eventsRef.current;

        const id = layerId.current;
        events.forEach((event: EventData) => mapService.map.on(event.name, id, event.callback));

        return () => events.forEach((event: EventData) => mapService.map.off(event.name, id, event.callback));
    }, [mapService, eventsRef]);

    return null;
};

export default Layer;
